import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class ConexionesService {
  constructor(public http: HttpClient, private env: EnvService) { }

  baseUrl = `${this.env.URL_API}/conexiones`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  createConexion(conexion): Observable<any> {
    const url = this.baseUrl;
    // console.log(conexion);

    return this.http.post(url, conexion).pipe(catchError(this.handleError));
  }

  getConexiones() {
    return this.http.get(`${this.baseUrl}`);
  }

  getConexion(id): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get(url, { headers: this.headers }).pipe(
      map((res: Response) => {
        return res || {};
      }),
      catchError(this.handleError)
    );
  }

  updateConexion(id, conexion): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    return this.http
      .put(url, conexion, { headers: this.headers })
      .pipe(catchError(this.handleError));
  }

  deleteConexion(id, id_usuarios_creador): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    const httpOptions = {
      headers: this.headers,
      body: { id_usuarios_creador },
    };
    return this.http
      .delete(url, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }

  getLastConexion(id: number) {
    return this.http.get(`${this.baseUrl}/ultimaconexion/${id}`);
  }
}
